import { useLocation, useRoutes } from 'react-router-dom';

import { Login } from '@/features/auth';
import { Availablity } from '@/features/availability';
import { useAuth } from '@/lib/auth';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import storage from '@/utils/storage';
import React, { useEffect } from 'react';
import { ENABLE_GOOGLE_CONVERSION } from '@/config';
import { Business, SetupBusiness } from '@/features/business';
import { useBuisiness } from '../features/business/api/getBisiness';

import { UseScreenOrientation } from '@/utils/Orientation';
import { setConfig } from 'dompurify';

type ContextType = {
  isLandscape: boolean;
  calendarView: string;
  setSelectedCalendarView: (data: string) => void;
  setBussiness: (data: Business | undefined) => void;
  setReferenceValues: (data: any) => void;
  business?: Business;
  refValues: any;
  isLoading: boolean;
  setIsLoading?: (data: boolean) => void;
  config: any;
  setConfig: (data: any) => void;
};
export const UserContext = React.createContext<ContextType | undefined>(undefined);

export const AppRoutes = () => {
  const isLandscape = UseScreenOrientation();
  const [calendarView, setCalendarView] = React.useState<string>();
  const [businessData, setBusinessData] = React.useState<Business>();
  const [refValues, setRefValues] = React.useState<any>();
  const [config, setConfig] = React.useState<any>();
  const [isDataLoading, setIsDataLoading] = React.useState<boolean>(false);
  const setSelectedCalendarView = (view: string) => {
    setCalendarView(view);
  };
  const setBusiness = (data: Business | undefined) => {
    setBusinessData(data);
  };
  const setLoading = (data: boolean) => {
    setIsDataLoading(data);
  };
  const setConfigValues = (data: any) => {
    setConfig(data);
  };
  const setReferenceValues = (data: any) => {
    setRefValues(data);
  };
  const auth = useAuth();
  const location: any = useLocation();
  let isInvitation =
    storage.getKey('isInvite') && location && location.pathname == '/invite-request';
  if (
    location.pathname.indexOf('userform') >= 0 ||
    location.pathname.indexOf('reset-password') >= 0
  ) {
    isInvitation = true;
    if (location.pathname.indexOf('reset-password') >= 0) {
      storage.clearToken();
    }
  }
  const commonRoutes = [{ path: '/', element: auth.user ? <Availablity /> : <Login /> }];
  const routes = auth.user && !isInvitation ? protectedRoutes : publicRoutes;
  const element = useRoutes([...routes]);

  // useEffect(() => {
  //   const windowRef: any = window;
  //   if (windowRef.gtag && ENABLE_GOOGLE_CONVERSION === 'no') {
  //     console.log("windowRef.gtag -----> ",windowRef.gtag);

  //     // windowRef.gtag('config', 'GTM-K5NR8SWD', {
  //     //   send_page_view: false,
  //     // });
  //   }
  // }, []);

  // useEffect(() => {
  //   if (location) {
  //     console.log('location change ---> ', location);
  //     const windowRef: any = window;
  //     // windowRef.gtag('event', 'page_view', {
  //     //   path: location.pathname,
  //     //   search: location.search,
  //     // });
  //   }
  // }, [location]);

  return (
    <UserContext.Provider
      value={{
        isLandscape: isLandscape ? isLandscape : false,
        setSelectedCalendarView: setSelectedCalendarView,
        calendarView: calendarView ? calendarView : '',
        setBussiness: setBusiness,
        setReferenceValues: setReferenceValues,
        business: businessData,
        refValues: refValues,
        setConfig: setConfigValues,
        setIsLoading: setLoading,
        isLoading: isDataLoading,
        config: config,
      }}
    >
      {element}
    </UserContext.Provider>
  );
};
